export default "__VITE_ASSET__Dgq0g25c__"